export default __webpack_public_path__ + "static/media/img13.c59470cf.svg";